import { addLocaleData as configure } from 'react-intl';
import en from 'react-intl/locale-data/en';

configure([...en]);
